var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 577,
    viewBox: "0 0 1170 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1521_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5971 514.392C24.219 517.083 26.9042 518.76 29.5947 518.138L73.4387 508.004C76.1293 507.382 77.8062 504.697 77.1843 502.006C76.5625 499.316 73.8774 497.639 71.1868 498.261L32.2143 507.269L23.2064 468.296C22.5846 465.606 19.8995 463.929 17.2089 464.55C14.5184 465.172 12.8415 467.858 13.4633 470.548L23.5971 514.392ZM659.969 347.266L663.644 350.656L663.716 350.578L663.785 350.496L659.969 347.266ZM70.0625 446.665L74.3034 449.314L70.0625 446.665ZM561.726 453.768L558.051 450.377L561.726 453.768ZM675.404 329.031L679.22 332.261L675.404 329.031ZM1152.92 0.255286C1145.16 2.83585 1137.44 5.5029 1129.75 8.25557L1133.12 17.6704C1140.73 14.9434 1148.39 12.3011 1156.08 9.74457L1152.92 0.255286ZM1083.98 25.8287C1068.84 32.0405 1053.86 38.5906 1039.05 45.472L1043.27 54.5407C1057.94 47.7233 1072.78 41.234 1087.77 35.08L1083.98 25.8287ZM995.072 67.1429C980.572 74.7038 966.253 82.5907 952.127 90.7965L957.15 99.4435C971.144 91.314 985.33 83.5004 999.696 76.0099L995.072 67.1429ZM910.303 116.384C896.559 125.23 883.018 134.389 869.691 143.852L875.481 152.006C888.684 142.63 902.099 133.557 915.715 124.793L910.303 116.384ZM830.372 173.143C817.498 183.2 804.847 193.553 792.431 204.197L798.94 211.789C811.24 201.244 823.773 190.987 836.528 181.024L830.372 173.143ZM755.946 236.948C744.046 248.13 732.391 259.593 720.99 271.33L728.163 278.297C739.458 266.669 751.005 255.313 762.794 244.235L755.946 236.948ZM687.641 307.268C682.224 313.38 676.872 319.557 671.588 325.8L679.22 332.261C684.456 326.076 689.758 319.956 695.124 313.901L687.641 307.268ZM671.588 325.8L667.729 330.359L675.362 336.82L679.22 332.261L671.588 325.8ZM660.011 339.477L656.152 344.036L663.785 350.496L667.644 345.938L660.011 339.477ZM656.293 343.876L631.733 370.501L639.083 377.282L663.644 350.656L656.293 343.876ZM582.612 423.752L558.051 450.377L565.402 457.158L589.962 430.532L582.612 423.752ZM558.051 450.377C552.994 455.86 547.641 460.861 542.045 465.385L548.332 473.161C554.306 468.332 560.014 462.998 565.402 457.158L558.051 450.377ZM504.365 487.491C490.656 492.979 476.307 496.317 461.829 497.536L462.668 507.501C478.116 506.2 493.436 502.637 508.082 496.775L504.365 487.491ZM418.188 494.794C403.976 491.772 390.158 486.663 377.243 479.502L372.394 488.247C386.19 495.897 400.944 501.35 416.108 504.575L418.188 494.794ZM342.628 452.852C337.642 447.663 332.958 442.032 328.626 435.959L320.485 441.766C325.099 448.235 330.095 454.241 335.417 459.781L342.628 452.852ZM328.626 435.959C323.504 428.777 317.935 422.179 311.989 416.164L304.877 423.194C310.446 428.828 315.672 435.017 320.485 441.766L328.626 435.959ZM270.208 385.979C254.55 378.238 237.859 373.265 220.883 371.031L219.579 380.946C235.493 383.04 251.125 387.7 265.776 394.944L270.208 385.979ZM169.385 372.61C152.578 375.88 136.223 381.866 121.069 390.552L126.042 399.228C140.222 391.1 155.538 385.491 171.294 382.426L169.385 372.61ZM81.215 423.239C75.6492 429.607 70.4943 436.534 65.8216 444.016L74.3034 449.314C78.6941 442.283 83.5307 435.785 88.7444 429.82L81.215 423.239ZM65.8216 444.016L55.4232 460.667L63.905 465.964L74.3034 449.314L65.8216 444.016ZM34.6263 493.967L24.2278 510.618L32.7096 515.915L43.1081 499.264L34.6263 493.967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1521_7",
    x: 0.33374,
    y: 0.255371,
    width: 1168.74,
    height: 576.012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1521_7",
    result: "effect2_dropShadow_1521_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1521_7",
    result: "effect3_dropShadow_1521_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1521_7",
    result: "effect4_dropShadow_1521_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1521_7",
    result: "effect5_dropShadow_1521_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1521_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/Line 3.df0cc387716de37d1b0f5e15a36ec224.svg";
export { ForwardRef as ReactComponent };